import {
  Grid,
  PlaceholderCategoryHeader,
  PlaceholderCategoryTree,
  PlaceholderTiles,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const CategoryStreamBackground = ({dataTestid = 'FullscreenDialog'}) => {
  return (
    <>
      {/* {Fake Category Page / Product Grid Behind the Overlay} */}
      <CategoryContainer data-testid={dataTestid}>
        <CategoryTree amount={20} />
        <Wrapper>
          <CategoryHeader />
          <ProductStream>
            <Grid>
              <PlaceholderTiles
                amount={8}
                TileWrapper={ListItem}
                disableSkeletonAnimation
              />
            </Grid>
          </ProductStream>
        </Wrapper>
      </CategoryContainer>
    </>
  );
};

const ListItem = styled.li``;

const CategoryContainer = styled.div`
  display: flex;

  ${tabletAndUpLinaria('margin-right: 30px;')};
`;

const CategoryTree = styled(PlaceholderCategoryTree)`
  display: none;

  ${tabletAndUpLinaria(
    `
      display: unset;
      width: 30%;
      min-width: 300px;
      margin-top: 50px;
    `,
  )}
`;

const CategoryHeader = styled(PlaceholderCategoryHeader)`
  display: none;

  ${tabletAndUpLinaria('display: unset;')}
`;

const Wrapper = styled.div`
  width: 100%;
`;

const ProductStream = styled.div`
  width: 100%;
`;
